export default "__VITE_ASSET__Ccd89qSJ__"